var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94727 3.72003C2.94727 2.6032 4.15132 1.89605 5.13609 2.43359L20.2885 10.7146C20.7609 10.9724 21.0544 11.4654 21.0544 12.001C21.0544 12.5366 20.7609 13.0296 20.2885 13.2874L5.13609 21.5684C4.67844 21.8184 4.12193 21.8098 3.67241 21.5456C3.2229 21.2814 2.94719 20.801 2.94727 20.282V3.72003Z",
    stroke: "#0F0F74",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.bf35593e27c51801225960f0f47d5f5b.svg";
export { ForwardRef as ReactComponent };